module.exports = __webpack_public_path__ + "static/media/24-9.3398423a.mp3";